export class AddedRevenueDataForGSearchResults {
    public constructor(init?: Partial<AddedRevenueDataForGSearchResults>) {
      Object.assign(this, init);
    }
        invoiceNumber: string;
        amountOfChange: number;
        lotNumber: string;
   }